import React, { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { InputProps, loadScript } from '@treatwell/ui';

import { InputError } from 'components/common/__BaseCommon';
import { withFormContext } from 'components/common/Form/withFormContext';

import style from './Captcha.scss';
import { BE_TURNSTILE_TOKEN_NAME, getSitekey } from './constants';
import { CaptchaFC, Errors } from './types';
import { captchaValidations } from './withCaptchaValidations';

export const TurnstileCaptcha: CaptchaFC = () => {
  const { setValue, trigger, errors } = useFormContext();
  const fields = captchaValidations(errors as Errors);
  const sitekey = getSitekey(window.location.hostname);

  const onNewToken = useCallback(
    (token) => {
      setValue(BE_TURNSTILE_TOKEN_NAME, token, { shouldValidate: true });
      trigger(BE_TURNSTILE_TOKEN_NAME);
    },
    [setValue, trigger],
  );

  useEffect(() => {
    window._onTurnstileLoaded = () => {
      window.turnstile.render('.cf-turnstile-container', {
        sitekey,
        theme: 'light',
        size: 'normal',
        callback: onNewToken,
      });
    };
    loadScript({
      id: 'turnstile-script',
      src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=_onTurnstileLoaded',
    });
  }, []);

  return (
    <div className={style.captchaContainer}>
      <div className="cf-turnstile-container"></div>
      <HiddenInput {...fields[BE_TURNSTILE_TOKEN_NAME]} />
    </div>
  );
};

const HI: React.FC<
  InputProps & {
    name: string;
    value?: string;
    dataTest?: string;
    hasError: boolean;
    errorMessage?: string;
  }
> = ({
  value,
  dataTest,
  name,

  hasError,
  errorMessage,
}) => (
  <>
    <input name={name} id={name} data-test={dataTest} value={value || ''} type="hidden" />
    {hasError && errorMessage && (
      <div className={style.errorMessage}>
        <InputError dataTest={dataTest} message={errorMessage} />
      </div>
    )}
  </>
);
const HiddenInput: typeof HI = withFormContext(
  //@ts-ignore
  HI,
);

// Extend Window interface to include turnstile properties
declare global {
  interface Window {
    _onTurnstileLoaded: () => void;
    turnstile: {
      render: (selector: string, options: any) => void;
    };
  }
}
